import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { SMALL_MARGIN, MIDDLE_MARGIN, LARGE_MARGIN, colorsPalette } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    errorWrapper: {
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    mainInfoWrapper: {
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: MIDDLE_MARGIN,
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
        paddingBottom: LARGE_MARGIN,
      },
    },
    leftPanel: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: MIDDLE_MARGIN,
      [theme.breakpoints.up('md')]: {
        maxWidth: 325,
        marginRight: MIDDLE_MARGIN,
        marginBottom: 0,
      },
    },
    pathwayInfoWrapper: {
      '&:not(:only-child)': {
        marginBottom: MIDDLE_MARGIN,
      },
      [theme.breakpoints.up('md')]: {
        '&:not(:only-child)': {
          marginBottom: LARGE_MARGIN,
        },
      },
    },
    pathwayProgressWrapper: {
      order: 0,
      marginBottom: MIDDLE_MARGIN,
      [theme.breakpoints.up('md')]: {
        marginBottom: 0,
      },
    },
    joinNowContainer: {
      marginBottom: MIDDLE_MARGIN,
      [theme.breakpoints.up('md')]: {
        marginBottom: LARGE_MARGIN,
      },
    },
    testBlockItem: {
      marginBottom: MIDDLE_MARGIN,
      '&:last-child': {
        marginBottom: 0,
      },
    },
    divider: {
      width: '100%',
      height: 3,
      background: colorsPalette.violet,
      opacity: 0.3,
      marginBottom: LARGE_MARGIN,
    },
  }),
);

export const useHeaderStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      fontSize: 24,
      fontWeight: 'bold',
      lineHeight: 1.2,
      marginBottom: 0,
      [theme.breakpoints.up('md')]: {
        fontSize: 28,
      },
    },
    description: {
      fontSize: 18,
      marginTop: SMALL_MARGIN,
      lineHeight: 1.5,
      [theme.breakpoints.up('md')]: {
        width: 620,
        fontSize: 20,
        marginTop: MIDDLE_MARGIN,
      },
    },
    categoriesWrap: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'flex-end',
      marginTop: MIDDLE_MARGIN,
      marginBottom: '-10px',
      '& > *': {
        marginRight: 10,
        marginBottom: 10,
      },
    },
  }),
);

export default useStyles;
